module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1UmeD"))).then(() => parcelRequire('d0iPb'));